<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header [nzTitle]="nzBreadcrumb">
    <ng-template #nzBreadcrumb>
      <div class="flex-center-between title-container">
        <nz-breadcrumb class="flex-center">
          <button style="margin-right: 6px" nz-button nzType="text" nzShape="circle" nzSize="default" (click)="goBack()">
            <app-st-icon class="text-dark" [bold]="true" name="arrow_back"></app-st-icon>
          </button>

          @if (!(isMobile$ | async)) {
            <!--   Desktop   -->
            <ng-container *ngFor="let item of breadcrumb$ | async">
              <nz-breadcrumb-item>
                <span *ngIf="item.navigate" class="cursor-pointer" [routerLink]="item.navigate">{{item.label}}</span>
                <span *ngIf="!item.navigate">{{ item.label }}</span>
              </nz-breadcrumb-item>
            </ng-container>
          } @else {
            <!--   Mobile   -->
            <ng-container *ngIf="(breadcrumb$ | async) as breadcrumb">
              <!--  Si el length del breadcrumb es 3 es que se esta en el detalle de Servicios  -->
              <app-st-icon *ngIf="breadcrumb.length === 3" style="margin-right: 5px"
                           [avatar]="true" [smallAvatar]="true"
                           [name]="gs.getServiceType(selectedService?.typeId || 0)?.icon || 'close'">
              </app-st-icon>

              <nz-breadcrumb-item>
                <span class="text-header-16 text-nowrap">{{ breadcrumb[breadcrumb.length - 1].label }}</span>
              </nz-breadcrumb-item>
            </ng-container>
          }
        </nz-breadcrumb>

        <button *ngIf="isMobile$ | async" (click)="toggleGlobalSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
          <app-st-icon [bold]="true" name="travel_explore"></app-st-icon>
        </button>
      </div>

      <!-- Mobile Search Filter -->
      <div *ngIf="showMobileSearchBar && (isMobile$ | async)" [ngClass]="mobileSearchClass">
        <button nzShape="circle" nzSize="default" nz-button nzType="text">
          <app-st-icon [bold]="true" name="add"></app-st-icon>
        </button>
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar [ngClass]="{'hide': (isMobile$ | async) && !showGlobalSearch}"></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  @if (templatesLoaded) {
    <nz-layout class="content-layout">
      <!-- Sección Izquierda (Main Content) -->
      <nz-content *ngIf="!(isMobile$ | async)" class="main-content">
        <ng-container *ngIf="mainTemplate" [ngTemplateOutlet]="mainTemplate"></ng-container>
      </nz-content>

      <!-- Sección Derecha (Side Content) -->
      <nz-sider [class.side-content]="!isCollapsed" [nzWidth]="(isMobile$ | async) ? '100%' : 475"
                [(nzCollapsed)]="isCollapsed" nzCollapsible [nzTrigger]="null"
                [nzCollapsedWidth]="(isMobile$ | async) ? 430 : 64" class="right-sidebar">
        @if (isCollapsed&&!(isMobile$ | async)) {
          <div class="flex flex-column flex-center flex-center-between side-content-collapsed" style="height: 100%">
            <div class="flex flex-column">
              <button nz-button nzType="text" (click)="toogleSideBar()">
                <app-st-icon name="left_panel_open" color="#666666" class='icon'></app-st-icon>
              </button>
             
            </div>

<!--            <button nz-button nzType="text" style="margin-bottom: 16px">-->
<!--              <app-st-icon name="chat_bubble" color="#171717" class='icon'></app-st-icon>-->
<!--            </button>-->
            <app-chat *ngIf="currentChat"
                      [minimalMode]="true"
                      [chat]="currentChat"
                      [chatName]="currentChatName || 'Sin nombre'"
                      (openSidebar)="openChat()"
                      style="margin-bottom: 16px">
            </app-chat>
          </div>
        } @else {

            <button *ngIf="!(isMobile$ | async)" nz-button nzType="text" (click)="toogleSideBar()" class="floating-button">
              <app-st-icon name="left_panel_close" color="#666666" class='icon'></app-st-icon>
            </button>
              <ng-container *ngIf="sideTemplate" [ngTemplateOutlet]="sideTemplate">

              </ng-container>

              <ng-container *ngIf="mainTemplate && (isMobile$ | async)"
                            [ngTemplateOutlet]="mainTemplate"></ng-container>

            <!-- Sección del Chat (Fijo en la parte inferior) -->
            <app-chat *ngIf="!(isMobile$ | async) && currentChat" [chatName]="currentChatName || 'Sin nombre'"
                      [chat]="currentChat" [sidebarExpanded]="sidebarExpanded"></app-chat>

        }
      </nz-sider>
    </nz-layout>
  }

  <!-- Router outlet para capturar la instancia del detail component; se oculta para que no se renderice duplicadamente -->
  <router-outlet (activate)="onActivate($event)" style="display: none;"></router-outlet>

  <app-chat *ngIf="(isMobile$ | async) && currentChat"
            [chatName]="currentChatName || 'Sin nombre'"
            [chat]="currentChat"></app-chat>
</nz-layout>
